import PropTypes from 'prop-types';

export const children = PropTypes.oneOfType([
	PropTypes.arrayOf(PropTypes.node),
	PropTypes.node
]);

export const values = (someObject) =>
	PropTypes.oneOf(Object.values(someObject));

export const keys = (someObject) => PropTypes.oneOf(Object.keys(someObject));

export const ref = PropTypes.oneOfType([
	PropTypes.func,
	PropTypes.shape({ current: PropTypes.any })
]);
